/**
 * usePackingOrder - Order details query for packing station
 *
 * Fetches order details for packing, including all items and their verification status.
 * Uses skipToken pattern for conditional queries when orderId or locationId is not available.
 *
 * @param orderId - The order ID to fetch, or null
 * @param locationId - The location ID for access control, or null
 * @returns TanStack Query result with order data
 */
import { trpc } from '@/lib/trpc';
import { skipToken } from '@tanstack/react-query';

export function usePackingOrder(orderId: string | null, locationId: string | null) {
  return trpc.packing.getPackingOrder.useQuery(
    orderId && locationId
      ? { orderId, locationId }
      : skipToken,
    {
      refetchOnWindowFocus: false,
      // Data will be refetched when mutation invalidates the query
    }
  );
}
